import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/PineTar/ProductShowcase";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet";

const Pinetar = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Helmet>
        <title>Pine Tar - Strong Pine Aroma & Classic Earthy Taste | BeyondBloom™</title>
        <meta
          name="description"
          content="Pine Tar is a potent strain known for its strong pine scent and a classic earthy taste, delivering a smooth and relaxing experience."
        />
        <meta
          name="keywords"
          content="Pine Tar strain, pine-scented cannabis, earthy taste, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Pine Tar - Strong Pine Aroma & Classic Earthy Taste | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Pine Tar is a potent strain known for its strong pine scent and a classic earthy taste, delivering a smooth and relaxing experience."
        />
        <meta property="og:image" content="/images/pine-tar.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/pine-tar" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pine Tar - Strong Pine Aroma & Classic Earthy Taste | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Pine Tar is a potent strain known for its strong pine scent and a classic earthy taste, delivering a smooth and relaxing experience."
        />
        <meta name="twitter:image" content="/images/pine-tar.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Pinetar;
